export var ControllerButtonSizes;
(function (ControllerButtonSizes) {
    ControllerButtonSizes["small"] = "small";
    ControllerButtonSizes["medium"] = "medium";
    ControllerButtonSizes["big"] = "big";
})(ControllerButtonSizes || (ControllerButtonSizes = {}));
